module.exports = "/fonts/opensanssemibold.woff";